import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { Box, Button } from '@mui/material';
import qs from 'qs';

import { CircularProgress } from '@components/_index';

import { CHIN_CHARACTER_ONLY } from '@constants/constants';
import { fetchOrderDetail } from '@template/store/order/slice';
import { setKycVerifyMsg } from '@template/store/verification/slice';

import API from '@api/index';
import { callAPI } from '@template/utils/apiCallback';

import { TickIco } from '@images';

const VerifyKycButton = ({ btnTxt, btnTxtVerifying }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { legalCurrency, transactionType } = useParams();
    const { displayName, wholeMobile, areaCode } = useSelector(
        (state) => state.verification
    );
    const [isKycVerifying, setIsKycVerifying] = useState(false);

    const verifyKyc = () => {
        const location = window.location;
        const queryUrl = qs.parse(location.search, { ignoreQueryPrefix: true });
        const { token, orderNo } = queryUrl;

        const payload = {
            token,
            orderNo,
            kycName: displayName,
            mobile: wholeMobile
        };
        dispatch(setKycVerifyMsg(''));
        setIsKycVerifying(true);

        callAPI({
            apiCall: () => API.order.kycVerify(payload),
            successCallback: () => {
                dispatch(fetchOrderDetail(legalCurrency, transactionType));
                return;
            },
            failedCallBack: () => {
                dispatch(
                    setKycVerifyMsg(
                        t('common.kycVerificationInfos.kycVerifyFailedMsg')
                    )
                );
            },
            errCallBack: () => {
                dispatch(
                    setKycVerifyMsg(
                        t('common.kycVerificationInfos.kycVerifyFailedMsg')
                    )
                );
            },
            finalCallBack: () => {
                setIsKycVerifying(false);
            }
        });
    };

    const isOnlyAreaCode = areaCode.length >= wholeMobile.length;
    const validateName =
        displayName.length <= 4 && CHIN_CHARACTER_ONLY.test(displayName);

    return (
        <Button
            className="btn btnConfirm"
            variant="contained"
            color="primary"
            disabled={
                !displayName ||
                !validateName ||
                !wholeMobile ||
                !areaCode ||
                isOnlyAreaCode ||
                isKycVerifying
            }
            onClick={() => verifyKyc()}>
            {isKycVerifying && <CircularProgress />}
            <Box className="content">
                <TickIco className="icon iconAddition iconTick" />
                <Box className="text">
                    {isKycVerifying ? btnTxtVerifying : btnTxt}
                </Box>
            </Box>
        </Button>
    );
};
export default VerifyKycButton;
